import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';

export class PlayerIconIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const jumpTween = this.getTween(transform.position);
        const fallTween = this.getTween(transform.position);
        const pulseTween = this.getTween(transform.scale);

        jumpTween.to({ y: -30.0 }, 300).easing(Easing.Quadratic.Out);
        fallTween.to({ y: 0 }, 500).easing(Easing.Bounce.Out);
        jumpTween.chain(fallTween);
        fallTween.chain(jumpTween);

        jumpTween.delay(3000).start(this.elapsedTime);

        pulseTween
            .to({ x: 1.1, y: 1.1 }, 1000)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start(this.elapsedTime);

        while (true) yield;
    }
}
